import type { Vector3 } from 'three';
import { type Pointer, getPointer } from './pointer';
import { allocate_heapBytes_array } from '@frontend/utility';

export const allocate_vector = (x: Vector3, datatype='float' as 'float' | 'int'): Pointer<[number, number, number]> => {
    const data = [ x.x, x.y, x.z ];
    const dir_vec_heapBytes = allocate_heapBytes_array(data, datatype);
    return getPointer(dir_vec_heapBytes);
};
